const _excluded = ["style", "className", "timeout", "isOpen", "children", "height", "onEntered", "onExited", "onAnimationStart", "onAnimationComplete", "as"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import Animation from '@adsk/alloy-react-animation';
import { useMeasure, useForwardedRef } from '@adsk/alloy-react-helpers';
import { stylePropType } from '@adsk/alloy-react-theme';

/**
 * Get the duration of the animation depending upon
 * the height provided.
 * @param {number} height of container
 */

function getAutoHeightDuration(height) {
  if (!height) return 0;
  const constant = height / 36;
  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10) / 1000;
}
const AnimateHeight = /*#__PURE__*/React.forwardRef(function (_ref2, _ref) {
  let {
      style,
      className,
      timeout,
      isOpen,
      children,
      height = 0,
      onEntered,
      onExited,
      onAnimationStart,
      onAnimationComplete,
      as: asProp
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded);
  const ref = useForwardedRef(_ref);
  const bounds = useMeasure(ref);
  const heightByState = isOpen ? 'auto' : height;
  const motionProps = {
    height: heightByState
  };
  const matrixState = isOpen ? 'entered' : 'exited';
  const Component = asProp || 'div';
  const onAnimationCompleteWrapper = x => {
    if (onAnimationComplete) {
      onAnimationComplete(x);
    }
    if (onEntered && isOpen) {
      onEntered();
    }
    if (onExited && !isOpen) {
      onExited();
    }
  };
  return /*#__PURE__*/React.createElement(Animation, _extends({
    style: [{
      overflow: 'hidden'
    }, style],
    className: className,
    initial: motionProps,
    animate: motionProps,
    transition: {
      ease: 'easeOut',
      duration: typeof timeout === 'number' ? timeout : getAutoHeightDuration(bounds.height)
    },
    onAnimationStart: onAnimationStart,
    onAnimationComplete: onAnimationCompleteWrapper
  }, rest), /*#__PURE__*/React.createElement(Component, {
    ref: ref
  }, typeof children === 'function' ? children(matrixState) : children));
});
AnimateHeight.displayName = 'AnimateHeight';
AnimateHeight.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The content to animate */
  children: PropTypes.any,
  /** Animation state */
  isOpen: PropTypes.bool.isRequired,
  /** Height animation timeout */
  timeout: PropTypes.number,
  /** Callback when exit animation is complete */
  onExited: PropTypes.func,
  /** Callback when enter animation is complete */
  onEntered: PropTypes.func,
  /** Callback when animation has started */
  onAnimationStart: PropTypes.func,
  /** Callback when animation is complete */
  onAnimationComplete: PropTypes.func,
  /** Min height for the collapse animation */
  height: PropTypes.number
};
export default AnimateHeight;
//# sourceMappingURL=AnimateHeight.js.map